<div class="row" *ngFor="let file of files; let i = index;">
    <div class="col-3">
        <div class="form-group">
            <input type="file" name="file-i"
                (change)="seleccionarArchivo($event, i)" class="form-control" />
        </div>
    </div>
    <div class="col-3">
        <button class="btn btn-danger" (click)="eliminarArchivo(i)">Eliminar</button>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <button class="btn btn-primary" (click)="agregarArchivo()">Agregar archivo</button>
    </div>
</div>